import { store } from '../../store';
import { subscribeLabSuppliesAction } from '../../ReduxSlices/LabSupplies/labSupplySlice';
import subscribeToCoreUpdates from '../core_updates_channel';

let unsubscribeLabSupplies = null;

export const initializeLabSupplySubscription = () => {
  if (unsubscribeLabSupplies) return;

  unsubscribeLabSupplies = subscribeToCoreUpdates("labSupplies", {
    "lab_supply.created": (data) => {
      store.dispatch(subscribeLabSuppliesAction({ action: "created", lab_supply: data }));
    },
    "lab_supply.updated": (data) => {
      store.dispatch(subscribeLabSuppliesAction({ action: "updated", lab_supply: data }));
    },
    "lab_supply.deleted": (data) => {
      store.dispatch(subscribeLabSuppliesAction({ action: "deleted", lab_supply: data }));
    }
  });
};

export const unsubscribeLabSupplySubscription = () => {
  if (unsubscribeLabSupplies) {
    unsubscribeLabSupplies();
    unsubscribeLabSupplies = null;
  }
};
